import performRequestBackend from "../../axios";

export const WEBSITE_INQUIRY_TYPE = "website_inquiry";

export const Forms = {
  createFormUser: async (body) => {
    const response = await performRequestBackend("/forms", "POST", body);
    return response;
  },
  getForms: async ({ page = 1, limit = 10, type, search, status } = {}) => {
    const params = { page, limit };
    if (type) params.type = type;
    if (search) params.search = search;
    if (status) params.status = status;
    const response = await performRequestBackend("/forms", "GET", null, params);
    return response;
  },
  updateFormStatus: async (id, status) => {
    const response = await performRequestBackend(`/forms/${id}/status`, "PATCH", { status });
    return response;
  },
  // Public enquiry form on the landing page.
  submitWebsiteInquiry: async ({ fullName, mobile, email, companyName, city, message, solution, source, meta }) => {
    const nameParts = fullName.trim().split(/\s+/);
    const body = {
      type: WEBSITE_INQUIRY_TYPE,
      first_name: nameParts[0] || "",
      last_name: nameParts.slice(1).join(" "),
      email: email.trim() || null,
      phone_number: mobile,
      country: "India",
      address: city.trim() || null,
      userinfo_meta: {
        full_name: fullName.trim(),
        company_name: companyName.trim(),
        city: city.trim(),
        solution,
        message: message.trim(),
      },
      consents_meta: { contact_consent: true },
      form_meta: {
        ...(meta || {}),
        source: source || "website",
        page: window.location.pathname,
        referrer: document.referrer || null,
      },
    };
    const response = await performRequestBackend("/forms", "POST", body);
    return response;
  },
};
